(ns dashboard.entity.recommendation.profile
  (:require ["react" :as react]
            [clojure.set :as set]
            [dashboard.entity.analysis.list :as analysis.list]
            [dashboard.entity.analysis.tree :as analysis.tree]
            [dashboard.entity.question.editable-answer-field :as edit.answer]
            [dashboard.entity.question.profile :as question.profile]))

(defn Footer [all-analyses
              already-added-analyses
              checked-analyses
              selected-question
              on-submit
              answer-options]
  (let [answer-data {:response (question.profile/question->response selected-question)
                     :additional-information (question.profile/question->comment selected-question)}
        chosen-options (some->> answer-options
                                (filter second)
                                (mapv first)
                                set)
        chosen-construct-ids (->> (cond->> checked-analyses
                                    (not (:analysis answer-options))
                                    (remove (comp (partial = :analysis) :source))
                                    (not (:recommended-analysis answer-options))
                                    (remove (comp (partial = :recommended-analysis) :source)))
                                  (mapv :construct-id)
                                  set)
        already-added-construct-ids (->> already-added-analyses
                                         vec
                                         (mapv :construct-id)
                                         set)]
    [:footer.card-footer
     [:div.card-footer-item
      [:button.button.is-primary.is-rounded.mr-4
       {:disabled (empty? chosen-options)
        :on-click (fn [_]
                    (on-submit
                     (->> all-analyses
                          (filterv
                           (comp (partial contains? (set/union chosen-construct-ids
                                                               already-added-construct-ids))
                                 :construct-id))
                          (mapv (comp first :applied-analyses))
                          set)
                     (select-keys answer-data chosen-options)
                     :overwrite))}
       "Write Response"]
      [:button.button.is-secondary.is-rounded.ml-4
       {:disabled (empty? chosen-options)
        :on-click (fn [_]
                    (on-submit
                     (->> all-analyses
                          (filterv
                           (comp (partial contains? (set/union chosen-construct-ids
                                                               already-added-construct-ids))
                                 :construct-id))
                          (mapv (comp first :applied-analyses))
                          set)
                     (select-keys answer-data chosen-options)
                     :append))}
       "Add to Response"]]]))

(defn AnswerPartToInclude
  [answer-options set-answer-options display-name key]
  [:div
   [:input
    {:type :checkbox
     :checked (get answer-options key)
     :on-change (fn [_] (set-answer-options #(update % key not)))}]
   "Add to " display-name])

(defn SelectedQuestion->Response
  [{:keys [question
           on-question-selected
           selected-question
           already-linked-construct-ids
           recommended-analyses
           all-analyses
           step-number
           step-fn
           checked
           set-checked
           answer-options
           set-answer-options]}]
  (let [handle-select
        (fn [source asa]
          (let [analysis (->> all-analyses
                              (filter (comp (partial = (:construct-id asa))
                                            :construct-id))
                              first)
                selected (-> (select-keys asa [:construct-id])
                             (assoc :version-id (-> analysis
                                                    :applied-analyses
                                                    first
                                                    :version-id))
                             (assoc :source source))]
            (if (contains? (->> checked (mapv :construct-id) set)
                           (:construct-id selected))
              (set-checked #(->> %
                                 (remove
                                  (fn [{:keys [construct-id]}]
                                    (= construct-id (:construct-id selected))))
                                 set))
              (set-checked #(conj % selected)))))]
    [:div.questions--answer-from-question
     [:div.questions--answer-from-question-answer-parts
      [:h6.is-5.title.mb-2.mt-4
       "Step "
       step-number
       ": "
       "Select elements from the Answer to base your Response on"]]

     [:div.questions--answer-from-question-answer-parts.level-left.my-0.is-align-items-flex-start.columns
      {:style {:gap "12px"}}
      [:div.column
       [AnswerPartToInclude answer-options set-answer-options "Response" :response]
       [:div.questions--answer-part-control
        [:f> edit.answer/EditableAnswerField
         :response
         "response"
         question.profile/question->response
         (fn [question _ value]
           (on-question-selected (assoc-in question [:selected-answer :response] value)))
         selected-question
         true]]]
      [:div.column
       [AnswerPartToInclude answer-options set-answer-options "Comment" :additional-information]
       [:div.questions--answer-part-control
        [:f> edit.answer/EditableAnswerField
         :additional-information
         "comment"
         question.profile/question->comment
         (fn [question _ value]
           (on-question-selected (assoc-in question [:selected-answer :additional-information] value)))
         selected-question
         true]]]]

     [:div.questions--answer-from-question-answer-parts.level-left.my-0.is-align-items-flex-start.columns.px-0
      {:style {:gap "6px"}}
      (when (-> selected-question :analyses count pos?)
        [:div.column.is-half
         [:div.questions--answer-from-question-answer-parts
          [AnswerPartToInclude answer-options set-answer-options "Analysis from Answer" :analysis]]
         [:div.questions--answer-from-question-analyses
          (->> selected-question
               :analyses
               (analysis.list/AnalysisCategoryTable
                false
                (partial analysis.tree/CheckboxAnalysisRow
                         {:on-select (partial handle-select :analysis)
                          :disabled (not (:analysis answer-options))
                          :on-click-construct (fn [_ asa] (handle-select :recommended-analysis asa))
                          :on-click-state (fn [_ asa] (handle-select :recommended-analysis asa))
                          :selected-construct-ids (->> checked (mapv :construct-id) set)
                          :on-expand identity
                          :expanded #{}
                          :expand-all false
                          :active-query true
                          :linked-construct-ids (set already-linked-construct-ids)
                          :search-result-construct-ids (->> selected-question
                                                            :analyses
                                                            (mapv :construct-id)
                                                            set)
                          :display-construct-ids (->> selected-question
                                                      :analyses
                                                      (mapv :construct-id)
                                                      set)})))]])
      (when recommended-analyses
        [:div.column.is-half
         [:div.questions--answer-from-question-answer-parts
          [AnswerPartToInclude answer-options set-answer-options "Recommended Analysis" :recommended-analysis]]

         [:div.questions--answer-from-question-analyses
          (->> recommended-analyses
               (take 3)
               (analysis.list/AnalysisCategoryTable
                false
                (partial analysis.tree/CheckboxAnalysisRow
                         {:on-select (partial handle-select :recommended-analysis)
                          :on-click-construct (fn [_ asa] (when (:recommended-analysis answer-options)
                                                            (handle-select :recommended-analysis asa)))
                          :on-click-state (fn [_ asa] (when (:recommended-analysis answer-options)
                                                        (handle-select :recommended-analysis asa)))
                          :disabled (not (:recommended-analysis answer-options))
                          :selected-construct-ids (->> checked (mapv :construct-id) set)
                          :on-expand identity
                          :expanded #{}
                          :expand-all identity
                          :active-query true
                          :linked-construct-ids (set already-linked-construct-ids)
                          :search-result-construct-ids (->> recommended-analyses
                                                            (take 8)
                                                            (mapv :construct-id)
                                                            set)
                          :display-construct-ids (->> recommended-analyses
                                                      (take 8)
                                                      (mapv :construct-id)
                                                      set
                                                      (analysis.tree/get-analysis-tree-displayed-construct-ids
                                                       all-analyses))})))]])]]))



(defn ProcessSteps
  [step-name info-panel process-name process-class step-actions]
  [:div.recommender-process-step.mb-0
   {:class process-class}
   [:div.level.my-0.recommender-process-step--title
    [:b.is-size-6 process-name]
    (->> step-actions
         (remove nil?)
         (map-indexed
          (fn [idx props]
            [:button.button.is-rounded.is-small.mr-1 props (inc idx)]))
         (into [:div.title.is-7.my-0.level-left
                [:span.mr-4 "Step "]]))]
   [:div.questions--process-step
    [:hr.my-1]
    [:div.level.my-0.columns.is-align-items-flex-start
     [:div.column
      {:class :is-half}
      [:h5.title.is-5.my-0 step-name]]
     [:div.notification.has-background-highlight.is-flex.mt-0.mb-2.is-size-6.p-2
      {:class [:column :is-half]}
      [:i.fas.fa-info-circle.icon]
      [:span.ml-2 info-panel]]]]])

